import './FiltersMobileSwitchPanel.css';
import React from 'react';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconChevronDown } from '../../../../resources/icons/IconChevronDown.svg';
const commonStyles = "c140phdr";
const ltrStyles = "l7y8ts2";
const rtlStyles = "rmuxv7s";
const FiltersMobileSwitchPanel = _ref => {
  let {
    filterState,
    labelText,
    filterPanelLabel,
    clearAll,
    ctaText,
    togglePanel,
    panelVisible,
    clearFilter,
    triggerFilterFieldOpen,
    pleaseSelectText,
    withMapModalView = false,
    filtersCount
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const renderItems = key => filterState[key].value.map((el, index) => filterState[key].value.length - 1 === index ? el : `${el}, `);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("button", {
    className: `${withMapModalView ? 'btn btn-secondary' : ''} panel-trigger `,
    onClick: togglePanel
  }, labelText, filtersCount > 0 && withMapModalView && ` (${filtersCount})`), /*#__PURE__*/React.createElement("div", {
    className: `
      filters__mobile-items-wrapper
      ${panelVisible ? 'filters__mobile-items-wrapper--visible' : ''}
    `
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: togglePanel
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      maxWidth: '100px',
      textAlign: 'center',
      lineHeight: '1.4'
    }
  }, filterPanelLabel)), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearAll)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__mobile-list"
  }, Object.keys(filterState).map(key => /*#__PURE__*/React.createElement("button", {
    className: "filters__mobile-list-button",
    key: key,
    onClick: () => {
      triggerFilterFieldOpen(key);
    }
  }, /*#__PURE__*/React.createElement("h5", null, filterState[key].title), /*#__PURE__*/React.createElement("p", null, filterState[key].value.length ? renderItems(key) : pleaseSelectText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "filters__mobile-list-button-icon"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer d-lg-none"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: togglePanel
  }, ctaText))));
};
export default FiltersMobileSwitchPanel;